import { render } from "./ViewProjects.vue?vue&type=template&id=475537c2&scoped=true&ts=true"
import script from "./ViewProjects.vue?vue&type=script&lang=ts"
export * from "./ViewProjects.vue?vue&type=script&lang=ts"

import "./ViewProjects.vue?vue&type=style&index=0&id=475537c2&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475537c2"]])

export default __exports__